import React from 'react';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  withHandlers,
  lifecycle
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import renderHTML from 'react-render-html';
import { sendLogin } from '../../auth/Auth';
import CloseButton from '../atoms/CloseButton';

const styles = {
  root: {
    position: 'absolute',
    width: '95%',
    // maxWidth: '355px',
    height: 'auto',
    maxHeight: '80%',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    backgroundColor: '#fff',
    padding: '40px 40px 20px',
    overflow: 'auto',
    outline: 'none',
    fontSize: 12,
    lineHeight: '16px',
    color: '#333333',
    borderRadius: 4
  },
  btnCloseDiv: {
    textAlign: 'left',
    marginTop: 20,
    marginLeft: '-40px',
    marginRight: '-40px',
    padding: '15px 32px 0px',
    borderTop: '1px solid #DDDDDD'
  },
  btnClose: {
    fontSize: 14,
    fontWeight: 'bold',
    width: '100%',
    marginBottom: 10
  },
  pubDate: {
    fontWeight: 'bold',
    marginTop: 5,
    textAlign: 'left'
  },
  titleDetail: {
    marginBottom: 20,
    lineHeight: 'normal'
  },
  content: {
    overflowWrap: 'break-word',
    lineHeight: 'normal'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  setPropTypes(propTypes),
  withState('openApprovalProgress', 'updateOpenApprovalProgress', false),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(({ classes, setDetailPost, params }) => {
  const closeAction = () => {
    setDetailPost(false);
  };

  return (
    <div className={classes.root}>
      <div className={classes.pubDate}>{params && `${params.pubDate}`}</div>
      <h1 className={classes.titleDetail}>{params && params.title}</h1>
      <div className={classes.content}>
        {params && renderHTML(params.content)}
      </div>

      <div className={classes.btnCloseDiv}>
        <CloseButton onClickAction={closeAction} color="default" />
      </div>
    </div>
  );
});

export default withRouter(withStyles(styles)(Main));
